export default __webpack_public_path__ + "static/media/face3.60728d30.png";